import { isError } from 'flux-standard-action';
import { metaExtractor, payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { VIRAL_CONTENT_STATE_STATUSES } from '../constants';

const requestMutationGenerator = (payload, { params }) => ({
  params: (currentParams) => ({ ...currentParams, ...params }),
  status: { $set: VIRAL_CONTENT_STATE_STATUSES.PENDING },
  error: { $set: null },
});

const successMutationGenerator = ({ clip, clips, meta }) => ({
  params: (currentParams) => ({ ...currentParams, meta }),
  clips: (currentClips) => [...new Set([...currentClips, ...clips, clip])],
  status: { $set: VIRAL_CONTENT_STATE_STATUSES.DONE },
  error: { $set: null },
});

const errorMutationGenerator = (error, { params }) => ({
  params: (currentParams) => ({ ...currentParams, ...params }),
  clips: { $set: [] },
  status: { $set: VIRAL_CONTENT_STATE_STATUSES.ERROR },
  error: { $set: error },
});

export const viralFetchAllRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const viralFetchAllSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const viralFetchAllFailureReducer = (currentState, action) =>
  updateState(
    currentState,
    errorMutationGenerator(payloadExtractor(action), metaExtractor(action)),
  );
